/**
 * badge.ts — O número no ícone do aplicativo, sincronizado com o sininho.
 *
 * O PROBLEMA QUE ISTO RESOLVE. O service worker PÕE o badge quando o push
 * chega, mas nada o TIRA quando a pessoa abre o sininho: o vermelho some da
 * tela e o número continua no ícone, na tela de início, para sempre. Badge que
 * não some é pior que badge nenhum — ele diz "tem coisa nova" quando não tem, e
 * em dois dias a pessoa aprende a ignorar o ícone. No celular, "ignorar"
 * costuma virar "desligar as notificações no sistema", de onde não se volta.
 *
 * A REGRA: o ícone conta a MESMA coisa que o sininho. Toda vez que aquele
 * número muda na tela, esta função é chamada.
 *
 * ONDE FUNCIONA: Android, iPhone com o app instalado na tela de início, e
 * Windows com o app instalado pelo Chrome ou Edge — é o mesmo `setAppBadge` nos
 * três. Onde não há suporte, tudo aqui vira silêncio, nunca erro: o badge é um
 * extra, e o sininho dentro do app continua sendo a fonte.
 */

/**
 * O tipo vai por `unknown` de propósito: o `lib.dom` novo já declara
 * `setAppBadge`/`clearAppBadge` como obrigatórios no `Navigator`, e estender a
 * interface tornando-os opcionais é conflito de tipo — `tsc --noEmit` deixa
 * passar e o build do projeto recusa.
 */
interface NavegadorComBadge {
  setAppBadge?: (n?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
}

export function sincronizarBadge(quantidade: number): void {
  const nav = navigator as unknown as NavegadorComBadge;
  try {
    if (quantidade > 0) void nav.setAppBadge?.(quantidade);
    else void nav.clearAppBadge?.();
  } catch {
    /* sem suporte: o app continua funcionando sem o número no ícone */
  }
}
